import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthPanel, useAuth, type AuthMode } from '@/features/auth';
import { FullscreenLoader } from '@/shared/ui';
import { ROUTES } from '@/shared/config/routes';
import { Seo } from '@/shared/seo';

/** Full-page auth for deep links / invites. The header modal covers the common case. */
export function AuthPage() {
  const { status } = useAuth();
  const location = useLocation();
  const [mode, setMode] = useState<AuthMode>('login');

  const from = (location.state as { from?: string } | null)?.from ?? ROUTES.home;

  if (status === 'loading') return <FullscreenLoader />;
  if (status === 'authenticated') return <Navigate to={from} replace />;

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md items-center px-6 py-16">
      {/* Sign-in has no search value and shouldn't compete with real pages. */}
      <Seo title="Sign in" noIndex />
      <div className="w-full rounded-3xl border border-border bg-background p-7 shadow-sm">
        <AuthPanel mode={mode} onModeChange={setMode} />
      </div>
    </div>
  );
}
